import { createAction } from '@reduxjs/toolkit';
import { ProfileForms } from './profile.config';
import {
  ProfileUpdateRequestPayload,
  SubmissionOutcome,
} from './profile.types';

export const userRequestedProfileUpdate = createAction<
  ProfileUpdateRequestPayload,
  'profile/USER_SUBMITTED_PROFILE_UPDATE_REQUEST'
>('profile/USER_SUBMITTED_PROFILE_UPDATE_REQUEST');

export const updateProfileStatus = createAction<
  Record<string, any>,
  'profile/UPDATE_PROFILE_STATUS'
>('profile/UPDATE_PROFILE_STATUS');

export const clearUsernameSuggestions = () =>
  updateProfileStatus({ suggestedUsernames: undefined });

export const setUsernameSuggestions = (suggestedUsernames: string[]) =>
  updateProfileStatus({ suggestedUsernames });

export const updateActiveProfileForm = createAction<
  ProfileForms | null,
  'profile/UPDATE_ACTIVE_FORM'
>('profile/UPDATE_ACTIVE_FORM');

export const closeAllProfileForms: () => ReturnType<
  typeof updateActiveProfileForm
> = () => updateActiveProfileForm(null);

export const updateSubmittingForm = createAction<
  ProfileForms | null,
  'profile/UPDATE_SUBMITTING_FORM'
>('profile/UPDATE_SUBMITTING_FORM');

export const updateLatestSubmissionOutcome = createAction<
  SubmissionOutcome,
  'profile/UPDATE_LATEST_SUBMISSION_OUTCOME'
>('profile/UPDATE_LATEST_SUBMISSION_OUTCOME');
